export const COMPARISON_VERSION = '1.0';
export const DEFAULTS_VERSION = 'simulator-constructor-2026-10-01';

export const TECHNICAL_FIELDS = [
  { key: 'desmame', label: 'Taxa de desmame (%)', min: 0.01, max: 100, step: 1 },
  { key: 'mortalidade', label: 'Mortalidade (%)', min: 0, max: 99, step: 0.1 },
  { key: 'touros', label: 'Touros (%)', min: 0, max: 100, step: 0.1 },
  { key: 'idade_entoure', label: 'Idade de acasalamento (anos)', min: 1, max: 3, step: 1, integer: true },
  { key: 'idade_venda', label: 'Idade de venda (anos)', min: 1, max: 3, step: 1, integer: true },
  { key: 'lotacao', label: 'Lotação (UA/ha)', min: 0.01, max: 20, step: 0.1 },
  { key: 'unidade_animal', label: 'Peso da unidade animal (kg)', min: 1, max: 3000, step: 5 },
  { key: 'descarte_vacas_ano', label: 'Descarte de vacas (%)', min: 0, max: 99, step: 1 },
  { key: 'descarte_touros_ano', label: 'Descarte de touros (%)', min: 0, max: 100, step: 1 },
];

export const WEIGHT_CATEGORIES = [
  ['vacas', 'Vacas'], ['touros', 'Touros'], ['bezerros', 'Bezerros'], ['bezerras', 'Bezerras'],
  ['novilha_1', 'Novilhas (13-24m)'], ['novilha_2', 'Novilhas (25-36m)'], ['novilha_3', 'Novilhas (>36m)'],
  ['novilho_1', 'Novilhos (13-24m)'], ['novilho_2', 'Novilhos (25-36m)'], ['novilho_3', 'Novilhos (>36m)'],
];
export const WEIGHT_FIELDS = WEIGHT_CATEGORIES.flatMap(([category, label]) => [
  { key: `peso_medio_${category}`, label: `${label} - peso médio (kg)`, min: 1, max: 3000, step: 5, category, type: 'average' },
  { key: `peso_venda_${category}`, label: `${label} - peso venda (kg)`, min: 1, max: 3000, step: 5, category, type: 'sale' },
]);
export const ECONOMIC_FIELDS = [
  { key: 'desembolso_cabeca_mes', label: 'Desembolso em reais por cabeça por mês', min: 0, max: 1000000, step: 1, numberFormat: 'both' },
  { key: 'preco_venda_novilhos', label: 'Preço de bezerros / novilhos (R$/kg PV)', min: 0, max: 10000, step: 0.1, numberFormat: 'decimal' },
  { key: 'preco_venda_novilhas', label: 'Preço de novilhas (R$/kg PV)', min: 0, max: 10000, step: 0.1, numberFormat: 'decimal' },
  { key: 'preco_venda_vacas', label: 'Preço das vacas de descarte (R$/kg PV)', min: 0, max: 10000, step: 0.1, numberFormat: 'decimal' },
  { key: 'preco_venda_touros', label: 'Preço dos touros de descarte (R$/kg PV)', min: 0, max: 10000, step: 0.1, numberFormat: 'decimal' },
];
export const SCENARIO_FIELDS = [...TECHNICAL_FIELDS, ...WEIGHT_FIELDS, ...ECONOMIC_FIELDS];
export const INPUT_KEYS = ['area_pastagem', 'vacas', 'tmf', 'novilho', 'preco_venda', ...SCENARIO_FIELDS.map(({ key }) => key)];

const clone = (value) => value == null ? null : JSON.parse(JSON.stringify(value));
const number = (value) => value === null || value === undefined || value === '' ? null : Number.isFinite(Number(value)) ? Number(value) : null;

export const createScenarioSnapshot = (simulator, calibrationReference = null) => {
  if (!simulator) return null;
  const inputs = Object.fromEntries(INPUT_KEYS.map((key) => [key, number(
    key === 'preco_venda_vacas' ? simulator.preco_venda_vacas_desc : key === 'preco_venda_touros' ? simulator.preco_venda_touros_desc : simulator[key]
  )]));
  return {
    version: COMPARISON_VERSION,
    mode: simulator.systemMode === 'cria' ? 'cria' : 'ciclo_completo',
    inputs,
    calibrationReference: clone(calibrationReference),
    priceReference: { source: 'currentScenario', customized: Boolean(simulator.precos_personalizados), currency: 'BRL', unit: 'kgLiveWeight' },
  };
};

export const scenarioSignature = (snapshot) => JSON.stringify(snapshot);

export const validateScenario = (snapshot) => {
  if (!snapshot || !['cria', 'ciclo_completo'].includes(snapshot.mode)) return ['scenario'];
  const errors = SCENARIO_FIELDS.filter(({ key, min, max, integer }) => {
    const value = snapshot.inputs[key];
    return !Number.isFinite(value) || value < min || value > max || (integer && !Number.isInteger(value));
  }).map(({ key }) => key);
  if (!Number.isFinite(snapshot.inputs.area_pastagem) || snapshot.inputs.area_pastagem <= 0) errors.push('area_pastagem');
  // All four goal calculations are executed by the existing engine.
  for (const key of ['vacas', 'tmf', 'novilho']) if (!Number.isFinite(snapshot.inputs[key]) || snapshot.inputs[key] <= 0) errors.push(key);
  if (snapshot.mode === 'cria' && snapshot.inputs.idade_venda !== 1) errors.push('idade_venda');
  return [...new Set(errors)];
};
